export const USER_TWITTER_SIGN_IN = 'USER_TWITTER_SIGN_IN';
export const USER_FACEBOOK_SIGN_IN = 'USER_FACEBOOK_SIGN_IN';
export const USER_GOOGLE_SIGN_IN = 'USER_GOOGLE_SIGN_IN';

export const USER_TWITTER_SIGN_IN_REQUEST = 'USER_TWITTER_SIGN_IN_REQUEST'
export const USER_FACEBOOK_SIGN_IN_REQUEST = 'USER_FACEBOOK_SIGN_IN_REQUEST';
export const USER_GOOGLE_SIGN_IN_REQUEST = 'USER_GOOGLE_SIGN_IN_REQUEST';

export const USER_TWITTER_SIGN_IN_RESULT = 'USER_TWITTER_SIGN_IN_RESULT';
export const USER_FACEBOOK_SIGN_IN_RESULT = 'USER_FACEBOOK_SIGN_IN_RESULT';
export const USER_GOOGLE_SIGN_IN_RESULT = 'USER_GOOGLE_SIGN_IN_RESULT';

export const USER_GOOGLE_SIGN_IN_TO_SERVER = 'USER_GOOGLE_SIGN_IN_TO_SERVER'


// WEBPACK FOOTER //
// ./src/constants/User/SignIn.js